document.addEventListener('DOMContentLoaded', function() {
  const loadMoreBtn = document.getElementById('load-more-btn');
  
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function(e) {
      e.preventDefault();
      
      const btn = this;
      const nextPage = parseInt(btn.getAttribute('data-next-page'));
      const totalPages = parseInt(btn.getAttribute('data-total-pages'));
      const articlesContainer = document.querySelector('.press-articles');
      const loadMoreText = btn.querySelector('.load-more-text');
      const loadMoreSpinner = btn.querySelector('.load-more-spinner');
      const originalText = loadMoreText.textContent;
      
      loadMoreText.style.display = 'none';
      loadMoreSpinner.style.display = 'inline-block';
      btn.disabled = true;
      
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('page', nextPage);
      
      fetch(currentUrl.toString())
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const allArticles = doc.querySelectorAll('.press-articles__article');
          const newArticles = Array.from(allArticles);
          
          newArticles.forEach((article, index) => {
            article.classList.add('newly-loaded');
            articlesContainer.appendChild(article);
            
            setTimeout(() => {
              article.style.animation = 'fadeInUp 0.6s ease forwards';
            }, index * 100);
          });
          
          const newLoadMoreBtn = doc.getElementById('load-more-btn');
          if (newLoadMoreBtn && nextPage < totalPages) {
            const newNextPage = nextPage + 1;
            btn.setAttribute('data-next-page', newNextPage);
            
            loadMoreText.style.display = 'inline';
            loadMoreSpinner.style.display = 'none';
            btn.disabled = false;
          } else {
            btn.parentElement.style.display = 'none';
          }
          
          if (window.theme && window.theme.initializeScrollAnimationTrigger) {
            window.theme.initializeScrollAnimationTrigger();
          }
        })
        .catch(error => {
          loadMoreText.style.display = 'inline';
          loadMoreSpinner.style.display = 'none';
          btn.disabled = false;
          
          loadMoreText.textContent = 'Erreur - Réessayer';
          setTimeout(() => {
            loadMoreText.textContent = originalText;
          }, 3000);
        });
    });
  }
});
